import { render } from "./CostosPersonalGroup.vue?vue&type=template&id=2f334486&scoped=true"
import script from "./CostosPersonalGroup.vue?vue&type=script&lang=js"
export * from "./CostosPersonalGroup.vue?vue&type=script&lang=js"

import "./CostosPersonalGroup.vue?vue&type=style&index=0&id=2f334486&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-2f334486"

export default script